import React from 'react';
import { ITopBannerComponentProps } from 'reactApp/ui/TopBanner/TopBanner';

export interface ITopBannerProps extends Omit<ITopBannerComponentProps, 'htmlContent'> {
    htmlContent?: string;
}

export function withRequiredHtmlContentHOC(
    ChildComponent: React.ComponentType<ITopBannerComponentProps>
): React.ComponentType<ITopBannerProps> {
    return function RequiredHtmlContentHOC({ htmlContent, ...props }) {
        return htmlContent ? <ChildComponent htmlContent={htmlContent} {...props} /> : null;
    };
}
